import DailyLeads from 'akasia-components/leads/dashboard/leads/DailyLeads.js';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import ErrorBoundary from '../../../components/common/ErrorBoundary';
import ConversionLineChart from './components/ConversionLineChart';
import InvestmentBarChart from './components/InvestmentBarChart';
import MarketingStats from './components/MarketingStats';
import SourcePieChart from './components/SourcePieChart';
import PostsByAccountChart from './components/PostsByAccountChart';
import PostsBySocialNetworkChart from './components/PostsBySocialNetworkChart';

const MarketingDashboard = () => {
    return (
        <div>
            {/* Marketing Header Card */}
            <Row className="mb-3">
                <Col md={12}>
                    <Card className="bg-light shadow-none">
                        <Card.Header className="d-flex align-items-center p-3">
                            <div>
                                <h6 className="mb-1 text-primary">Bienvenido al</h6>
                                <h4 className="mb-0 text-primary fw-bold">
                                    Panel de Marketing
                                    <span className="text-info fw-medium"> — Estadísticas, Leads y ROI</span>
                                </h4>
                            </div>
                        </Card.Header>
                    </Card>
                </Col>
            </Row>

            {/* Marketing Stats Panel */}
            <Row className="mb-3">
                <Col xs={12}>
                    <ErrorBoundary>
                        <MarketingStats />
                    </ErrorBoundary>
                </Col>
            </Row>

            {/* Each main chart on its own row */}
            <Row>
                <Col className="col-12 mb-3">
                    <ErrorBoundary>
                        <DailyLeads />
                    </ErrorBoundary>
                </Col>
            </Row>

            {/* Posts by Account Chart */}
            <Row className="g-3 mt-3">
                <Col xs={12}>
                    <Card>
                        <Card.Body>
                            <Card.Title>Posts by Advertising account</Card.Title>
                            <ErrorBoundary>
                                <PostsByAccountChart />
                            </ErrorBoundary>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Posts by Social Network Chart */}
            <Row className="g-3 mt-3">
                <Col xs={12}>
                    <Card>
                        <Card.Body>
                            <Card.Title>Posts by Social Media Channel</Card.Title>
                            <ErrorBoundary>
                                <PostsBySocialNetworkChart />
                            </ErrorBoundary>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* ROI on its own full-width row */}
            <Row className="g-3 mt-3">
                <Col xs={12}>
                    <Card>
                        <Card.Body>
                            <Card.Title>Return on Investment (ROI)</Card.Title>
                            <InvestmentBarChart />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Remaining secondary charts in one row */}
            <Row className="g-3 mt-3">
                <Col lg={6} md={12}>
                    <Card>
                        <Card.Body>
                            <Card.Title>Leads source</Card.Title>
                            <SourcePieChart />
                        </Card.Body>
                    </Card>
                </Col>

                <Col lg={6} md={12}>
                    <Card>
                        <Card.Body>
                            <Card.Title>Cost per Lead</Card.Title>
                            <ConversionLineChart />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default MarketingDashboard;

